import { NgFor } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';

import { Subject } from 'rxjs';

import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { SVGIcon, xIcon } from "@progress/kendo-svg-icons";

import { QueryPanelConnectorService, QueryPanelContentConnectorService } from 'src/app/modules/fwcore/services';
import { QueryPanelSummaryItem } from 'src/app/modules/fwcore/models';

@Component({
  selector: 'criteria-summary-box',
  standalone: true,
  styleUrls: ['./criteria-summary-box.component.scss'],
  templateUrl: './criteria-summary-box.component.html',
  imports: [ButtonsModule, NgFor]
})

export class CriteriaSummaryBox {
  /*-------------------------- Internal properties  ------------------*/
  protected destroy$ = new Subject();
  protected selectedFilters: QueryPanelSummaryItem[] = [];
  protected xicon: SVGIcon = xIcon;
  protected ccSub: any;
  protected subscription: any;

  /*-------------------------- Input / Outputs --------------------------------*/
  @Output() itemDeleted: EventEmitter<QueryPanelSummaryItem> = new EventEmitter();

  /*-------------------------- Constructor  --------------------------*/
  constructor (
    protected criteriaService: QueryPanelConnectorService,
    protected contentConnectorService: QueryPanelContentConnectorService,
    protected cdr: ChangeDetectorRef) {
    this.subscription = this.criteriaService.onMessage().subscribe(message => {
      if (message) {
        switch (message.type) {
          case "add":
            if (message.item) { this.addItem(message.item); }
            break;
          case "clear":
            this.selectedFilters = [];
            break;
          case "delete":
            if (message.item) { this.removeItem(message.item); }
            break;
          case "load":
            this.criteriaService.isLoaded("_");
            break;
        }
      }
    });

    this.ccSub = this.contentConnectorService.onMessage().subscribe(message => {
      if ((message) && (message.type == "search")) {
        this.selectedFilters.forEach(itm => itm.cssclass = "applied");
      }
    });
  }

  /*-------------------------- ng --------------------------*/
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  /*-------------------------- Public methods --------------------------*/
  public addItem(addedItem: QueryPanelSummaryItem) {
    if (addedItem) {
      addedItem.cssclass = "new";
      this.selectedFilters = [...this.selectedFilters, addedItem];
    }
  }

  public removeItem(removedItem: QueryPanelSummaryItem) {
    if (removedItem) {
      this.selectedFilters = this.selectedFilters.filter((i) =>
        (i.id !== removedItem.id)
        || (i.controlName !== removedItem.controlName));
    }
  }

  //public trackFilters(i: number) {
  //  return i;
  //}

  /*-------------------------- Event handlers --------------------------*/
  onButtonClick(e: PointerEvent, id: string) {
    if (id) {
      let items = this.selectedFilters.filter((i) => i.id == id);
      if (items.length) {
        this.selectedFilters = this.selectedFilters.filter((i) => i.id !== id);
        //this.itemDeleted.emit(result[0]);
        this.criteriaService.removeItem(items[0], false);
      }
    }
  }
}
